import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "../auth/auth.service";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ReservationService {
  entity: string = "/reservations";

  constructor(private http: HttpClient, private authService: AuthService) {}

  count_waiting(): Promise<any> {
    return firstValueFrom(
      this.http.get(environment.api + this.entity + "/get/count-waiting", {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      })
    );
  }

  change_reservation_studio(reservation: string, data: any) {
    return this.http.post(
      environment.api + this.entity + "/" + reservation + "/make-some-changes",
      data,
      {
        headers: {
          Authorization: "Bearer " + this.authService.currentUserValue.token,
          "Content-Type": "application/json",
        },
      }
    );
  }

  notifConfirmation(id: any, data: any): Promise<any> {
    return firstValueFrom(
      this.http.post(
        environment.api + this.entity + "/" + id + "/notif-confirmation",
        data,
        {
          headers: {
            Authorization: "Bearer " + this.authService.currentUserValue.token,
            "Content-Type": "application/json",
          },
        }
      )
    );
  }
}
